export const CITY_SEARCH_QUERY_MIN_LENGTH = 3;

export const MOSCOW_CITY_ID = 110;
